import { Box, Button } from "@mui/material";
import { makeStyles } from '@mui/styles'
import * as React from "react";
import { useDropzone } from "react-dropzone";
import { DataAPIContext, GET_ONE } from '../api';
import { url2filename } from "../utils";
import { UploadIcon } from "./actionIcons";
import FileActionRow from "./FileActionRow";

const useStyles = makeStyles(theme => ({
    helperText: {
        color: theme.palette.secondary.main,
        marginTop: theme.spacing(1),
    },
}));

const isLocalFile = (file) => typeof File !== 'undefined' && file instanceof File;

const fileLabel = (props) => {
    const { file } = props;
    if (isLocalFile(file)) {
        return file.name;
    }
    if (file.constructor === String) {
        return props.label || url2filename(file);
    }
    return file.name || url2filename(file.file || '');
};

// CP-5559: [UPLOAD FILE] until there is a file, then the shared file row (name that opens/downloads the file,
// blue Replace, red trash). `indirect_link` fetches a stored file through the API (`indirect_link_resource`,
// default `attachment`) instead of linking to it.
const UploadDocumentButton = (props) => {
    const classes = useStyles();
    const dataAPI = React.useContext(DataAPIContext);
    const { file, disabled } = props;

    const onDrop = (acceptedFiles) => {
        props.onSelect && acceptedFiles[0] && props.onSelect(acceptedFiles[0]);
    }

    const onClearFile = props.onClearFile || (() => {
        props.onSelect && props.onSelect(null, file);
    });

    const dz = useDropzone({
        noClick: true,
        noKeyboard: true,
        maxFiles: 1,
        onDrop: onDrop,
        accept: props.accept,
        multiple: false
    });

    const downloadAttachment = () => {
        const resource = props.indirect_link_resource || 'attachment';
        dataAPI(GET_ONE, `${resource}/${file.id}`, { urlSuffix: props.indirect_link_suffix || null }).then(async res => {
            const body = await res.response.blob();
            const url = window.URL.createObjectURL(body);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = file.name;
            a.target = '_blank';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            setTimeout(() => {
                document.body.removeChild(a);
            }, 100);
        });
    }

    return (<Box>
        <input {...dz.getInputProps()}/>
        {file ? (
            <FileActionRow
                name={fileLabel(props)}
                file={file}
                onOpen={props.indirect_link && !isLocalFile(file) && file.id ? downloadAttachment : undefined}
                onReplace={dz.open}
                onDelete={onClearFile}
                disabled={disabled}
                tooltipProps={props.tooltipProps}
            />
        ) : (
            <Button disabled={disabled} size={props.size || "medium"} color="primary" variant="outlined" startIcon={<UploadIcon />} onClick={dz.open}>
                {props.customLabel ? props.customLabel : "Upload file"}
            </Button>
        )}

        { props.helperText ? <div className={classes.helperText}>{props.helperText}</div> : null }

    </Box>);
}

export default React.memo(UploadDocumentButton);
